import Icon from './Icons'
import { Edit, ItemHeading, ItemRow, ItemWrapper, Summary } from './BookingStep.styles'
import { FlexibleHeading as Heading, Spacing } from '@big-red-group/storefront-common-ui'

const BookingStep: React.FC<{
  children: React.ReactNode
  index: number
  currentStep: number
  onReset: () => void
  updateCurrentStep: (index: number) => void
  isDisabled: boolean
  collapsed: boolean
  skeleton?: boolean
  dataTestId?: string
  title?: string
  summary?: string
  hideUntil?: boolean
}> = ({
  children,
  onReset,
  index,
  currentStep,
  updateCurrentStep,
  isDisabled,
  collapsed,
  skeleton,
  dataTestId,
  title,
  summary,
  hideUntil,
}) => {
  if (hideUntil) {
    return <></>
  }

  if (skeleton) {
    return (
      <ItemWrapper active={false} skeleton>
        <ItemHeading completed={false}>
          <Heading size="XXS" color="text-primary-light" weight="bold" dataTestId="booking-step-title">
            {title}
          </Heading>
        </ItemHeading>
      </ItemWrapper>
    )
  }

  const active = !collapsed

  return (
    <>
      <ItemWrapper
        data-testid={dataTestId}
        className={isDisabled ? 'disabled' : ''}
        onClick={() => {
          updateCurrentStep(index)
        }}
        active={active}
      >
        {title && (
          <>
            <ItemHeading className="total-row" completed={!active}>
              <Heading size="XXS" dataTestId="booking-step-title" weight="bold">
                {title}
              </Heading>
              <Icon name="checkmarkCircle" width={20} height={20} />
            </ItemHeading>
            <Spacing size="S" />
          </>
        )}
        {active ? (
          <>{children}</>
        ) : (
          <ItemRow className="total-row">
            {summary && (
              <Summary data-testid="booking-step-summary" dangerouslySetInnerHTML={{ __html: summary }}></Summary>
            )}
            <Edit
              data-testid="edit-cart-item"
              onClick={() => {
                updateCurrentStep(index)
                onReset()
              }}
            >
              Edit
            </Edit>
          </ItemRow>
        )}
      </ItemWrapper>
    </>
  )
}

export default BookingStep
